import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'

export const recurrentExpenseLastExpenseSchema = z.object({
  date: z.string(),
  amount: z.number(),
  currency: z.nativeEnum(Currency),
})

export const recurrentExpenseResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  description: z.string().nullable(),
  amount: z.number().nullable(),
  currency: z.nativeEnum(Currency),
  dayOfMonth: z.number(),
  creationTime: z.string(),
  active: z.boolean(),
  endDate: z.string().nullable(),
  notifyDaysBefore: z.number().nullable(),
  notifyTime: z.string().nullable(),
  notifyMessage: z.string().nullable(),
  lastCreatedAt: z.string().nullable(),
  lastNotifiedAt: z.string().nullable(),
  accountId: z.string().guid(),
  categoryId: z.string().guid(),
  groupId: z.string().guid().nullable(),
  userId: z.string().guid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastExpense: recurrentExpenseLastExpenseSchema.nullable(),
  nextCreationDate: z.string().nullable(),
})

export type RecurrentExpenseResponseDto = z.infer<typeof recurrentExpenseResponseSchema>
